module.exports = __webpack_public_path__ + "static/img/homePlan4.8bfa1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homePlan4.png
// module id = iehz
// module chunks = 3